import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { Results } from '../controls/advanced-gridview/models/results-T';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from '../controls/advanced-gridview/services/advanced-service';
import { Channel } from '../models/channel';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class ChannelService extends CrudService implements AdvancedService<Channel> {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<Channel>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/channels`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<Channel>(Channel, x);

                return res;
            })
        );
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): Observable<Blob> {
        const headers = this.getExportHeader(context, filters, generalFilters, sortInfos);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/channels/export`, { headers: headers, responseType: 'blob' }).pipe(
            map((res: any) => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                return blob;
            })
        );
    }

    update(ChannelId: number, Channel: Channel): Observable<Channel> {
        // Appel de la Web Api
        return this.http
            .put<Channel>(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/channels/${ChannelId}`, Channel, this.getDefaultHttpOptions())
            .pipe(
                map((x) => {
                    return x;
                })
            );
    }

    delete(ChannelId: number): Observable<boolean> {
        // Appel de la Web Api
        return this.http.delete<Channel>(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/channels/${ChannelId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return true;
            })
        );
    }

    add(Channel: Channel): Observable<Channel> {
        // Appel de la Web Api
        return this.http.post<Channel>(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/channels`, Channel, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }

    get(ChannelId: number): Observable<Channel> {
        // Appel de la Web Api
        return this.http.get<Channel>(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/channels/${ChannelId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }
}
